import * as types from './types';
import {MutationTree} from 'vuex';
import {User, UserState} from '@/types';
import {NEWSLETTER, NEWSLETTER_CONSENT} from '@/constants/subscriptions';

const mutations: MutationTree<UserState> = {

  [types.INVITATION_KEY_ERROR_MESSAGE](state, status) {
    state.invitationKeyErrorMessage = status;
  },

  [types.PROCESSING_INVITATION_KEY](state, bool) {
    state.processingInvitationKey = bool;
  },

  [types.SET_UUID](state, uuid) {
    state.uuid = uuid;
  },

  [types.FETCH_USER_DETAILS_SUCCESS](state, data: User) {
    state.user = { ...data };
  },

  [types.SAVE_USER_DETAILS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },

  [types.SET_SUBSCRIPTIONS](state, data) {
    let newsletter = {};

    if (!data.length) {
      newsletter = { checked: false, value: NEWSLETTER_CONSENT };
      data.push(newsletter);
    } else if (data[0] === NEWSLETTER) {
      newsletter = { checked: true, value: NEWSLETTER_CONSENT };
      data[0] = newsletter;
    }

    state.subscriptions = [newsletter];
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.ts